export const navigate = {
	PREVIOUS: "PREV",
	NEXT: "NEXT",
	TODAY: "TODAY",
	DATE: "DATE",
} as const;

export const views = {
	MONTH: "month",
	WEEK: "week",
	WORK_WEEK: "work_week",
	DAY: "day",
	AGENDA: "agenda",
} as const;
